import { Component, OnInit, ViewChild, AfterViewChecked, ChangeDetectorRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KbwService } from '../../services/kbwService.service';
import { ExamInfo, ExamBaseData } from '../../../models/examInfo.model';
import { Router } from '@angular/router';
import { MessageService } from '../../services/messageService.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HeaderComponent } from '../header/header.component';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import {ThemePalette} from '@angular/material/core';
import  Utils  from '../../../app/helpers/Utils';

@Component({
    selector: 'app-bookselect',
    templateUrl: './bookselect.component.html',
    styleUrls: ['./bookselect.component.scss'],
    providers: [KbwService, MessageService],
    standalone: false
})
export class BookselectComponent implements OnInit, AfterViewChecked {
  constructor(
    public translate: TranslateService,
    private kbwService: KbwService,
    private router: Router,
    private messageService: MessageService,
    private cdRef: ChangeDetectorRef,
    ) { }
  @ViewChild(HeaderComponent)
  color: ThemePalette = 'accent';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  isLoadnig = true;
  bookType = '';
  private headerComp: HeaderComponent;
  trainings: Array<ExamBaseData>;
  selectedExam: number;
  message: string;
  subscription: Subscription;
  langs: any;
  selectedLang: any;
  public kbklangs = [
    {id: 1, name: 'gb', desc: 'English', code: 'en-GB', order: 2},
    {id: 2, name: 'pl', desc: 'Polski', code: 'pl-PL', order: 1},
    {id: 3, name: 'de', desc: 'Deutsch', code: 'de-DE', order: 3},
    {id: 14, name: 'ro', desc: 'Română', code: 'ro-RO', order: 8},
    {id: 5, name: 'bg', desc: 'Български', code: 'bg-BG', order: 5},
    {id: 10, name: 'hu', desc: 'Magyar', code: 'hu-HU', order: 6},
    {id: 10, name: 'hr', desc: 'Hrvatski', code: 'hr-HR', order: 7},
    {id: 10, name: 'ua', desc: 'Українська', code: 'uk-UA', order: 4},
    {id: 4, name: 'ru', desc: 'Русский', code: 'ru-RU', order: 9}
  ];
  public kbwlangs = [
    {id: 1, name: 'pl', desc: 'Polski', code: 'pl-PL', order: 1},
    {id: 2, name: 'de', desc: 'Deutsch', code: 'de-DE', order: 2},
    {id: 3, name: 'gb', desc: 'English', code: 'en-GB', order: 3},
    //{id: 10, name: 'hu', desc: 'Magyar', code: 'hu-HU', order: 6},
    {id: 10, name: 'ua', desc: 'Українська', code: 'uk-UA', order: 4},
  ];

  ngAfterViewChecked(): void {
    // this.headerComp.isHiddenMenu = true;
    this.cdRef.detectChanges();
  }

  setLang(langVal){
    this.bookType = Utils.getBookType();
    Utils.setLang(this.translate, langVal, this.bookType);
  }
  ngOnInit() {
    this.bookType = Utils.getBookType();
    sessionStorage.clear();
    this.subscription = this.messageService.getMessage().subscribe(
      message => {
        this.message = message;
      },
      err => { },
      () => { }
      );
    let bookType = Utils.getBookType();
    if(bookType === 'KBK'){
      this.langs = this.kbklangs;
    } else if(bookType === 'KBW') {
      this.langs = this.kbwlangs;
    } else {
      this.langs = this.kbklangs;
    }
    Utils.setLang(this.translate, sessionStorage.getItem('lang'), this.bookType);

  }


  selectionChanged(value) {
    if(value === 'kbw'){
      window.open(`http://${environment.kbwDomain}/trainingselect?lang=${sessionStorage.getItem('lang')}&source=bookselect`, '_self');
    } else {
      window.open(`http://${environment.kbkDomain}/trainingselect?lang=${sessionStorage.getItem('lang')}&source=bookselect`, '_self')
    }
  }
  // onClick() {
  //   this.router.navigate(['/videotraining']);
  // }
}
